import { useLocation, useNavigate } from 'react-router-dom';
import Navbar from './Navbar';
import { useContext, useEffect, useState } from 'react';
import UserProfile from './UserProfile';
import BillingPage from './BillingPage';
import { UserContext } from '../Context/UserContext';
import { pricingData } from '../Common/PricingData';
import { handleRazorpayPayment } from '../Utils/Razorpay';
import FeedbackPopup from '../Common/FeedbackPopup';
import FooterComponent from '../Common/FooterComponent';
import { sentryLog } from '../Utils/SentryLog';
import { getLqzyParams } from '../Utils/GetLqzyParams';
import { toast } from 'react-toastify';
import { sheetsExtensionPricingData } from '../Common/SheetsExtensionPricingData';
import ExtensionNavbar from './ExtensionNavbar';
import axios from 'axios';
import FamewallEmbed from 'react-famewall'
/* global gtag */
/* global gtag_report_conversion */

const APP_BASE_URL = process.env.NODE_ENV === 'development' 
    ? "http://localhost:3000" 
    : "https://www.easyimagetotext.com";

const API_BASE_URL = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_LOCAL_API_URL : process.env.REACT_APP_API_URL;

const lemonSqzyQueryParams = getLqzyParams();

const isLemonSqueezyTestMode = false;
//pay links
const topUp100PayLink = !isLemonSqueezyTestMode ? `https://easyimagetotext.lemonsqueezy.com/checkout/buy/c14cfaaa-7273-498a-91e9-9360bc0ee2f7?embed=1&enabled=970835` : `https://easyimagetotext.lemonsqueezy.com/buy/1bcea74f-c906-47a3-af5d-0e3414edb9ce?enabled=971763`;
const topUp500PayLink = !isLemonSqueezyTestMode ? `https://easyimagetotext.lemonsqueezy.com/checkout/buy/d147b22c-8f5c-4d91-83af-74b315fc3a95?embed=1&enabled=970837` : `https://easyimagetotext.lemonsqueezy.com/buy/9d5ae9e2-9a3f-42bd-a30b-b1c98aa781d1?enabled=971764`;
const topUp1000PayLink = !isLemonSqueezyTestMode ? `https://easyimagetotext.lemonsqueezy.com/checkout/buy/dac976e6-8012-4817-ac53-4ffe3a195a76?embed=1&enabled=970838` : `https://easyimagetotext.lemonsqueezy.com/buy/3272136b-ba52-44d5-bc06-2b4882fe0ab0?enabled=971765`;

const monthly100PayLink = !isLemonSqueezyTestMode ? `https://easyimagetotext.lemonsqueezy.com/checkout/buy/238ae6d9-42ef-40c1-ab3d-d6eb148f2a8c?embed=1&enabled=970840` : `https://easyimagetotext.lemonsqueezy.com/buy/a4ea4fed-692a-4c6a-ac87-c21badcad6e7?enabled=971766`;
const monthly500PayLink = !isLemonSqueezyTestMode ? `https://easyimagetotext.lemonsqueezy.com/checkout/buy/1d4940a4-aadc-4b06-a2fc-8d3db585bd17?embed=1&enabled=970843` : `https://easyimagetotext.lemonsqueezy.com/buy/df7317cb-2b01-413f-8f98-fc7e89f96769?enabled=971768`;
const monthly1000PayLink = !isLemonSqueezyTestMode ? `https://easyimagetotext.lemonsqueezy.com/checkout/buy/9624301c-c971-49ed-84b4-20e3dacac3df?embed=1&enabled=970844` : `https://easyimagetotext.lemonsqueezy.com/buy/97f8865b-9ff2-435d-a1dc-ea346c488f69?enabled=971770`;
//

function SheetsExtensionPricingPage({ isIndianUser }){

    const { user, setUser } = useContext(UserContext);
    
    const [showFeedbackPopup, setShowFeedbackPopup] = useState(false);
    const [userDiscountCode, setUserDiscountCode] = useState("");
    const [isDiscountApplied, setIsDiscountApplied] = useState(false);
    const [fromExtension, setFromExtension] = useState(false);
    const [numOfTopUpCredits, setNumOfTopUpCredits] = useState(100);
    const [numOfSubCredits, setNumOfSubCredits] = useState(100);
    const [topUpAmtPerImg, setTopUpAmtPerImg] = useState('0.15');//need to cross-check with rates and plans as of todays date
    const [subscriptionAmtPerImg, setSubscriptionAmountPerImg] = useState('0.1');//need to cross-check with rates and plans as of todays date
    const [topUpPayLink, setTopUpPayLink] = useState(topUp100PayLink);
    const [subscriptionPayLink, setSubscriptionPayLink] = useState(monthly100PayLink);

    const isShowConsole = process.env.NODE_ENV === 'development';

    const location = useLocation();
    const navigate = useNavigate();

    isShowConsole && console.log('pricing page user check: ', user);
    isShowConsole && console.log("Current Path:", location.pathname); 

    useEffect(() => {
        document.title = "Convert PDF to Google Sheets in 1 click | Convert PDF Bank Statement to CSV | 1-click PDF to Google Sheets Converter, PDF to CSV converter";
        const planAmount = localStorage.getItem("pendingPlanAmount");
        const planType = localStorage.getItem("pendingPlanType");
        const pendingSheetsPlanLink = localStorage.getItem("pendingSheetsPlanLink");

        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('source') === 'extension') {
            sessionStorage.setItem('fromExtension', 'true');
            setFromExtension(true);
        }
      
        if (planAmount && planType) {
            try {
                handleRazorpayPayment(Number(planAmount), planType, setUser, openContactForm);
            } catch (err) {
                isShowConsole && console.error('handleRazorpayPayment failed in useEffect:', err);
                sentryLog(`PricingPage.js - useEffect RazorpayPayment failed: ${err?.message || err} | user: ${JSON.stringify(user)}`);
            }
            localStorage.removeItem("pendingPlanAmount");
            localStorage.removeItem("pendingPlanType");
        }
        if(pendingSheetsPlanLink){
            try {
                window.open(
                    pendingSheetsPlanLink,
                    "_blank"
                );
            } catch (err) {
                isShowConsole && console.error('pending paypal plan link failed to open in useEffect in PricingPage.js:', err);
                sentryLog(`PricingPage.js - useEffect pending paypal plan link open failed: ${err?.message || err} | user: ${JSON.stringify(user)}`);
            }
            localStorage.removeItem("pendingSheetsPlanLink");
        }
    }, []);

    const showSuccessToast = () => {
      try{
        toast.success(
          <div className='verificationSuccessToast'>
            <span>
                Payment successful! 🎉 Refresh the add-on sidebar to see your credits. 
            </span>
          </div>,
          {
            className: "verificationSuccessToastContainer",
            autoClose: 4000, 
            closeButton: false,
            onClose: () => {
                if (sessionStorage.getItem('fromExtension') === 'true') {
                    sessionStorage.removeItem('fromExtension');
                    setTimeout(() => window.close(), 100); 
                }
            }
          }
        );
      }catch(err){
        isShowConsole && console.error("error in showSuccessToast: ", err);
        sentryLog(`Razorpay.js - showSuccessToast failed: ${err?.message || err}`);
      }
    }

    useEffect(() => {
        const shouldNotifyUserUpgrade = localStorage.getItem("shouldNotifyUserUpgrade");

        if(shouldNotifyUserUpgrade === 'true'){
            showSuccessToast();
            localStorage.removeItem("shouldNotifyUserUpgrade");
        }
        
    }, [user])

    const openContactForm = e => {
        try{
            navigate(`/sheets-extension-contact-us${lemonSqzyQueryParams}`);
        }catch(err){
            isShowConsole && console.error('error in openContactForm method: ', err);
            sentryLog(`PricingPage.js - openContactForm failed: ${err?.message || err} | user: ${JSON.stringify(user)}`);
        }
    }

    const handleTopUpCreditsChange = e => {
        try{
            let newPlanPrice = (e.target.value == 100 ? '0.15' : e.target.value == 500 ? '0.08' : e.target.value == 1000 ? '0.07' : '');
            let newPayLink = (e.target.value == 100 ? topUp100PayLink : e.target.value == 500 ? topUp500PayLink : e.target.value == 1000 ? topUp1000PayLink : '');
            setTopUpPayLink(newPayLink);
            setTopUpAmtPerImg(newPlanPrice);
            setNumOfTopUpCredits(e.target.value);
        }catch(err){
            isShowConsole && console.error('error in handleTopUpCreditsChange method: ', err);
            sentryLog(`PricingPage.js - handleTopUpCreditsChange failed: ${err?.message || err} | user: ${JSON.stringify(user)}`);
        }
    }

    const handleSubCreditsChange = e => {
        try{
            let newPlanPrice = (e.target.value == 100 ? '0.1' : e.target.value == 500 ? '0.05' : e.target.value == 1000 ? '0.04' : '');
            let newPayLink = (e.target.value == 100 ? monthly100PayLink : e.target.value == 500 ? monthly500PayLink : e.target.value == 1000 ? monthly1000PayLink : '');
            setSubscriptionPayLink(newPayLink);
            setSubscriptionAmountPerImg(newPlanPrice);
            setNumOfSubCredits(e.target.value);
        }catch(err){
            isShowConsole && console.error('error in handleSubCreditsChange method: ', err);
            sentryLog(`PricingPage.js - handleSubCreditsChange failed: ${err?.message || err} | user: ${JSON.stringify(user)}`);
        }
    }

    const showErrorToast = e => {
        try{
            toast.error(
            <div className='paymentFailureToast'>
                <span> 
                Something went wrong. Please try again, or <a href="#" onClick={(e) => { e.preventDefault(); openContactForm();}}>Contact Support</a> for help.
                </span>
            </div>,
            {
                className: "paymentFailureToastContainer",
                autoClose: 4000, 
                closeButton: false
            }
            );
        }catch(err){
            isShowConsole && console.error("error in showErrorToast: ", err);
            sentryLog(`SheetsExtensionPricingPage.js - showErrorToast failed: ${err?.message || err}`);
        }
    }

    const handleManageSubscription = async(e) => {
        try{
            const params = {
                forSheetsExtension: true
            };

            const res = await axios.get(`${API_BASE_URL}/api/get-customer-portal-link`, { withCredentials: true, params: params });
            
            let customerPortalUrl = res?.data?.portalUrl;
            if(customerPortalUrl){
                window.open(customerPortalUrl, '_blank');
            }
        }catch(err){
            isShowConsole && console.error('error in handleManageSubscription method: ', err);
            showErrorToast();
            sentryLog(`BillingPage.js - handleManageSubscription failed: ${err?.message || err}`);
        }
    }

    const openTextOcrPricingPage = e => {
        try{
            window.open(
                'https://www.easyimagetotext.com/pricing',
                "_blank"
            );
        }catch(err){
            isShowConsole && console.error('error in openTextOcrPricingPage method: ', err);
            sentryLog(`PricingPage.js - openTextOcrPricingPage failed: ${err?.message || err} | user: ${JSON.stringify(user)}`);
        }
    }

    const initateCrispChatbot = e => {
        try{
            // If Crisp is already loaded, open it immediately
            if (window.$crisp) {
                window.$crisp.push(["do", "chat:open"]);
            } else {
            // If not loaded yet, wait for the ready event
                window.CRISP_READY_TRIGGER = () => {
                    window.$crisp.push(["do", "chat:open"]);
                };
            }
        }catch(err){
            isShowConsole && console.error('error in initateCrispChatbot method: ', err);
            sentryLog(`PricingPage.js - initateCrispChatbot failed: ${err?.message || err} | user: ${JSON.stringify(user)}`);
        }
    }

    const openTableOcrFAQPage = e => {
        try{
            window.open(
                'https://www.easyimagetotext.com/sheets-extension-faq',
                "_blank"
            );
        }catch(err){
            isShowConsole && console.error('error in openTableOcrFAQPage method: ', err);
            sentryLog(`PricingPage.js - openTableOcrFAQPage failed: ${err?.message || err} | user: ${JSON.stringify(user)}`);
        }
    }

    const pricingElements = (user !== undefined) ? sheetsExtensionPricingData.map((ele, idx) => {

        const isFeatures = ele.title === 'All plans include';
        let featuresList;
        if(isFeatures){
            featuresList = ele.features.map((feat, idx) => <li key={idx} style={{whiteSpace: 'normal'}}>{feat}</li>)
        }
        const isSubscription = ele.title === 'Subscription Plans';
        const isTopUp = ele.title === 'Top Up Plans';
        const perVal = ele.title === "Pro Weekly" ? 'week' : ele.title === 'Pro Monthly' ? 'month' : ele.title === 'Pro Yearly' ? 'year' : '';
        const billingPeriodInfo = ele.title === "Pro Weekly" ? 'weekly' : ele.title === 'Pro Monthly' ? 'monthly' : ele.title === 'Pro Yearly' ? 'yearly' : '';
        const extractionMsg = ele.title === 'Free' ? (ele.features.usageLimit + ' extractions per day') : (ele.features?.usageLimit + ' Extractions & Translations');
        const validityMsg = ele.title === "Pro Weekly" ? 'Valid for 7 days' : ele.title === 'Pro Monthly' ? 'Valid for 30 days' : ele.title === 'Pro Yearly' ? 'Valid for 365 days' : '';
        const billingMsg = ele.title === "Pro Weekly" ? 'Valid for 7 days' : ele.title === 'Pro Monthly' ? 'Billed monthly' : ele.title === 'Pro Yearly' ? 'Billed yearly' : '';

        const showActiveMsg = false;
        // (
        //     (isFeatures && user && !user.isPremium) ||
        //     (user?.isPremium && user?.planType === ele.title)
        //   );

        const currencySymbol = "$";//isIndianUser === null || isIndianUser ? '₹' : '$';
        const rate = ele.foreignRate;//isIndianUser === null || isIndianUser ? ele.rate : ele.foreignRate;

        const showTagline = ele.title === 'Pro Monthly' || ele.title === 'Pro Yearly';
        const tagLine = ele.title === 'Pro Monthly' ? 'Most popular' : ele.title === 'Pro Yearly' ? 'Best Value' : '';

        const planPrice = isSubscription ? subscriptionAmtPerImg : isTopUp ? topUpAmtPerImg : '';

        return(
            <div style={{overflowY: 'auto'}} className={`planContainer ${ele.title} ${(user?.isExtPremium && isSubscription) ? 'extPremium' : ''}`} key={idx}>
                {showTagline && <div className='tagLine'>{tagLine.toUpperCase()}</div>}
                <div className='planNameDiv'>
                    <div className='planName'>{ele.title}</div>
                    <div className='planDesc sheetsAddon'>{isSubscription ? "(Billed monthly)" : isTopUp ? "(Pay once, top up anytime)" : ""}</div>
                    {/* {isFeatures ? (showActiveMsg && <div className={`activeMsg`}>(Active)</div>) : <div className={`activeMsg ${showActiveMsg ? 'show' : 'hide'}`}>(Active)</div>} */}
                </div>
                {!isFeatures && (isIndianUser !== null) && <div style={{display: 'none'}} className={`planRate ${user?.isExtPremium ? '' : ''}`}>
                    <div className='val'>{currencySymbol}{planPrice}</div>
                    <div className='duration'>/Credit</div>
                </div>}
                {/* {isSubscription && <div style={{opacity: 1.0, fontSize: '13px', margin: '20px 0px 20px 0px'}} className={`billingPeriodInfo ${user?.isExtPremium ? '' : ''}`}>( Auto-renews every month until you cancel )</div>} */}
                {!isFeatures && isSubscription && <div className="options-wrapper">
                    <div className='options-container'>
                        {ele.plans.map((option, index) => (
                            <div className='option-container'>
                                <label key={index} className="radio-label">
                                    <div className='lhs'>
                                        <input
                                            type="radio"
                                            name="subscription-option"
                                            value={option.credits}
                                            checked={numOfSubCredits == option.credits}
                                            onChange={handleSubCreditsChange}
                                        />
                                        <div>{option.label}</div>
                                    </div>
                                    <div className='planAmount'>${option.amount} /mo</div>
                                </label>
                            </div>
                        ))}
                    </div>
                </div>}
                {!isFeatures && isTopUp && <div className="options-wrapper">
                    <div className='options-container'>
                        {ele.plans.map((option, index) => (
                            <div className='option-container'>
                                <label key={index} className="radio-label">
                                    <div className='lhs'>
                                        <input
                                            type="radio"
                                            name="pay-as-you-go-option" 
                                            value={option.credits}
                                            checked={numOfTopUpCredits == option.credits}
                                            onChange={handleTopUpCreditsChange}
                                        />
                                        <div>{option.label}</div>
                                    </div>
                                    <div className='planAmount'>${option.amount}</div>
                                </label>
                            </div>
                        ))}
                    </div>
                </div>}
                {!isFeatures && <div className={`upgradeDiv ${user?.isExtPremium ? '' : ''}`}><div className='upgradeBtn' onClick={async() => {
                    try {
                        //if (isIndianUser === null) return;
                        if(isSubscription && user?.isExtPremium){
                            handleManageSubscription();
                            return;
                        }

                        let finalPaymentLink = isSubscription ? subscriptionPayLink : isTopUp ? topUpPayLink : '';
                    
                        let paymentLink = `${finalPaymentLink}${finalPaymentLink.includes('?') ? '&' : '?'}checkout[custom][googleId]=${user?.googleId}&checkout[custom][source]=extension`;
                        if(!user){
                            localStorage.setItem("pendingSheetsPlanLink", paymentLink);
                            initiateLogin();
                        }else{
                            //to notify backend whenever a user clicks BUY or SUBSCRIBE button
                                const actionType = isSubscription ? "Subscribe" : "Buy_TopUp";
                                const creditAmt = isSubscription ? numOfSubCredits : numOfTopUpCredits;
                                
                                // Background ping - no 'await', does not delay UI
                                axios.post(`${API_BASE_URL}/api/lemonsqueezy/checkout-intent`, {
                                    googleId: user?.googleId,
                                    plan: actionType,
                                    amount: creditAmt,
                                    source: "extension"
                                }, { withCredentials: true }).catch(err => console.error(err));
                            //

                            window.LemonSqueezy.Url.Open(paymentLink);
                        }
                    } catch (err) {
                        isShowConsole && console.error('upgradeBtn upgrade failed:', err);
                        sentryLog(`PricingPage.js - upgradeBtn upgrade failed: ${err?.message || err} | user: ${JSON.stringify(user)}`);
                    }
                }}>{isSubscription ? (user?.isExtPremium ? "Manage Subscription" : "Subscribe") : "Buy Now"}</div><div className='paymentTrustNote'>🔒 Secure payment via Lemon Squeezy</div></div>}
                {/* {isTopUp && 
                    <div className='topUpNote'>
                        <span style={{fontWeight: 550}}>NOTE:</span> 
                        <br/>
                        <span style={{display: 'block', marginTop: '8px'}}>Top-up credits & Subscription credits are independent of each other.<span style={{display: 'block', marginTop: '5px', textDecoration: 'underline', color: 'blue', cursor: 'pointer'}} onClick={openTableOcrFAQPage}>Refer FAQ for more clarity</span></span>
                    </div>} */}
                {isFeatures && <div className='features' style={{height: 'auto'}}>
                    <ul>
                        {isFeatures && 
                            <>
                                {featuresList}
                            </>
                        } 
                    </ul>
                </div>}
                {isFeatures && 
                    <div className='partitionNote'>
                        {/* <div className='supportContainer'>
                        Have questions or feedback? <span className='chatCta' onClick={initateCrispChatbot}>Send a quick message</span>
                        </div> */}
                        {/* <div className='noteHeader'>IMPORTANT:</div><div className='noteContent'>Credits purchased on this page are exclusively for the Google Sheets Extension <b>Convert PDF to Google Sheets™</b>.</div> */}
                    </div>
                }
            </div>
        )
    }) : null;
    
    const initiateLogin = async () => {
      try{
            const query = getLqzyParams();
            await fetch(`${API_BASE_URL}/api/set-redirect`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include', // ✅ critical for session cookie
                body: JSON.stringify({ path: `/sheets-extension-pricing${query}` })
            });
      
            window.location.href = `${API_BASE_URL}/auth/google`;
      }catch(err){
          isShowConsole && console.error('error in initiate login method: ', err);
          sentryLog(`PricingPage.js - initiateLogin failed: ${err?.message || err}`);
      }
    }
    
    return(
            <div className='parentDiv'>
                <div className='mainDiv pricingPage sheetsAddon'>
                    <div className='header'>
                        <ExtensionNavbar />
                    </div>
                    <div className='contentDiv'>
                        <div className='containerDiv'>
                            <div className='title'>
                                <div className='main'>Simple Pricing</div>
                                <div className='sub'>Pay only for what you need</div>
                            </div>
                            <div className='contentBox'>
                                <div className='content' style={{width: '91%', height: '80%'}}>
                                    {pricingElements}
                                </div>
                                {/* <div className='infoNote'>
                                    Lock in now at the best rates! Prices may increase soon.
                                </div> */}
                            </div>
                        </div>
                    </div>
                    <div className='testimonials'>
                        <FamewallEmbed
                            wallUrl="convert-pdf-to-google-sheets"
                            // carouselMode={true}
                        />
                    </div>
                    {showFeedbackPopup && <FeedbackPopup closeFeedbackPopup={() => setShowFeedbackPopup(false)}/>}
                </div>
                <FooterComponent forSheetsExtension={true} setShowFeedbackPopup={setShowFeedbackPopup}/>
            </div>
    )
}

export default SheetsExtensionPricingPage;